import ViewAllButton from '@Components/Button/ViewAllButton/ViewAllButton'
import ClassroomCard from '@Components/Cards/ClassroomCard'
import SkeletonCard from '@Components/Utilities/Skeleton/Components/SkeletonCard'
import SkeletonCarousel from '@Components/Utilities/Skeleton/Components/SkeletonCarousel'
import { Swiper } from '@Components/Utilities/Swiper'
import { FlexLayout } from '@eduact/ed-system'
import { SectionWrapper } from '@Features/LandingPage/Assets/LandingPage.styled'
import { useGetClassroomsQuery } from '@Features/LandingPage/LandingPageApi/LandingPageApi'
import { useAppSelector } from '@Hooks/ReduxHooks'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionTitle } from '../Sections.styled'

const OnlineClassroomsSection: React.FC = () => {
	const { data, isLoading, isFetching } = useGetClassroomsQuery()
	const {
		classroomsSections: { online_cl },
	} = useAppSelector(state => state.settings)
	const [t] = useTranslation('landingPage', { keyPrefix: 'courses' })

	return (
		<React.Fragment>
			<SkeletonCarousel my={'5.25rem'} hasTitle isLoading={isLoading || isFetching} numberOfItems={4} renderComponent={<SkeletonCard />}>
				{
					<SectionWrapper my={{ sm: '2.8rem', lg: '5.25rem' }}>
						{data && data.data.length > 0 && (
							<div>
								<FlexLayout alignItems={'baseline'} justifyContent={'space-between'}>
									<SectionTitle>
										<label>{t('online_classrooms')}</label>
									</SectionTitle>
									<ViewAllButton />
								</FlexLayout>
								<Swiper isIndicator padding={'1rem'} withProgress gridGap={'2rem'}>
									{data.data
										.filter(_ => _.type === 'online')
										.map((cl, index) => {
											return (
												<ClassroomCard
													badgeLabel={cl.type}
													title={cl.title}
													grade={cl.educationYears?.[0]?.name ?? ''}
													subject={cl.category.name}
													subjectImage={cl.category.icon}
													thumbnail={cl.thumbnail}
													instructor={cl.instructor.user.first_name}
													classroom={cl}
													key={`${cl.id}-${index}`}
												/>
											)
										})}
								</Swiper>
							</div>
						)}
					</SectionWrapper>
				}
			</SkeletonCarousel>
		</React.Fragment>
	)
}

export default OnlineClassroomsSection
